// src/components/buttonChoice.jsx
import {React, useEffect, useState} from "react";
import { Box, Tabs, Tab, Button, useTheme } from "@mui/material";

const PLACES = ["site", "plugin", "theme", "cve"];

const BasicButtons = ({
  place,
  onSiteButtonClick,
  onPluginButtonClick,
  onThemeButtonClick,
  onCVEButtonClick,
  role,
}) => {
  // Ce composant est remonté à chaque changement d'onglet (chaque table rend son
  // propre BasicButtons) : l'état initial doit donc déjà valoir `place`, sinon
  // l'indicateur repart de "Sites" et l'animation part dans le mauvais sens.
  const [value, setValue] = useState(() =>
    PLACES.includes(place) ? place : "site"
  );
  const theme = useTheme();
  const isOnet = role === "onet";
  const isCompass = role === "compass";

  useEffect(() => {
    if (PLACES.includes(place)) {
      setValue(place);
    }
  }, [place]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === "site") onSiteButtonClick && onSiteButtonClick();
    if (newValue === "plugin") onPluginButtonClick && onPluginButtonClick();
    if (newValue === "theme") onThemeButtonClick && onThemeButtonClick();
    if (newValue === "cve") onThemeButtonClick && onCVEButtonClick();
  };

  return (
    <Tabs
      value={value}
      onChange={handleChange}
      aria-label="Choix des tables"
      sx={{
        display: "inline-flex",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
        boxShadow: "0px -1px 3px -1px rgba(0,0,0,0.08), 0px -1px 2px 0px rgba(0,0,0,0.06), -2px 0px 3px -1px rgba(0,0,0,0.05), -1px 0px 2px 0px rgba(0,0,0,0.04)",
        backgroundColor: theme.palette.background.paper,
        "& .MuiTab-root": {
          borderRight: `1px solid ${theme.palette.divider}`,
          color: theme.palette.text.primary,
          "&:last-of-type": { borderRight: "none" },
          "&.Mui-focusVisible": {
            backgroundColor: "transparent",
          },
        },
        "& .Mui-selected": {
          color: theme.palette.mode === 'dark' ? "white !important" : `${theme.palette.text.primary} !important`,
          backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : "rgb(238, 238, 238)",
        },
        "& .MuiTabs-indicator": {
          backgroundColor: isOnet ? "#06305C" : isCompass ? "#C4AC66" : "#F7E900",
        },
        "& .MuiTouchRipple-root": {
          display: "none",
        },
      }}
    >
      <Tab value="site" label="Sites" />
      <Tab value="plugin" label="Plugins" />
      <Tab value="theme" label="Themes" />
      {role==="admin" && (
      <Tab value="cve" label="CVE" />)}
    </Tabs>
  );
};

export default BasicButtons;
